import React, { useContext } from 'react'
import Login from './pages/Login'
import { Context } from './Context'
import {SessionManager} from '../src/components/RemoteConsoles/SessionManager'

import 'primereact/resources/themes/nova-light/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import './layout/layout.scss'
import './App.scss'
import { Routes } from './Routes'

export const App = () => {
  const { isAuth, userLogged } = useContext(Context)

  return !isAuth ? <Login></Login> : userLogged && <SessionManager><Routes userLogged={userLogged} /></SessionManager>
}
